// @ts-nocheck
import * as React from "react";

const CopyLine: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                d="M12.33 3A2.68 2.68 0 0 1 15 5.67L14.999 9H18a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3h-6a3 3 0 0 1-2.995-2.824L9 18l-.001-3.001L5.67 15A2.68 2.68 0 0 1 3 12.33V5.67A2.68 2.68 0 0 1 5.67 3h6.66ZM18 11h-6a1 1 0 0 0-.993.883L11 12v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1Zm-5.67-6H5.67C5.3 5 5 5.3 5 5.67v6.66c0 .37.3.67.67.67l3.329-.001L9 12a3 3 0 0 1 3-3h.999L13 5.67c0-.37-.3-.67-.67-.67Z"
                fill="currentColor"
                fillRule="evenodd"
            />
        </svg>
    );
};

export default React.memo(CopyLine);
